export default function sortArtifacts(artifacts) {
	if (!artifacts) {
		return artifacts;
	}

	// Sort artifacts by:
	// 1. Creation date (newer artifacts are more relevant)
	// 3. Name (alphabetically, with numeric sorting)
	return [...artifacts].sort(
		(a, b) =>
			b.created?.toDate() - a.created?.toDate() || a.name.localeCompare(b.name, undefined, { numeric: true }),
	);
}
